import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
    {
        path:"/",
        name:"",
        component:()=>import('@/page/index.vue'),
    },
    {
        path:"/index",
        name:"index",
        component:()=>import('@/page/index.vue'),
    },
    {
        path:"/login",
        name:"login",
        component:()=>import('@/page/login.vue'),
    },
    {
        path:"/member",
        name:"member",
        component:()=>import('@/page/member.vue'),
    },
    {
        path:"/recharge",
        name:"recharge",
        component:()=>import('@/page/recharge.vue'),
    },
    {
        path:"/shop",
        name:"shop",
        component:()=>import('@/page/shop.vue'),
    },
    {
        path:"/task",
        name:"task",
        component:()=>import('@/page/task.vue'),
    },
    {
        path:"/order",
        name:"order",
        component:()=>import('@/page/order.vue'),
    },
    {
        path:"/okOrder",
        name:"okOrder",
        component:()=>import('@/page/okOrder.vue'),
    },
    {
        path:"/praiseOrder",
        name:"praiseOrder",
        component:()=>import('@/page/praiseOrder.vue'),
    },
    {
        path:"/commission",
        name:"commission",
        component:()=>import('@/page/commission.vue'),
    },
    {
        path:"/download",
        name:"download",
        component:()=>import('@/page/download.vue'),
    },
    {
        path:"/plan",
        name:"plan",
        component:()=>import('@/page/plan.vue'),
    },
    {
        path:"/agentRecord",
        name:"agentRecord",
        component:()=>import('@/page/agentRecord.vue'),
    },
    {
        path:"/agent",
        name:"agent",
        component:()=>import('@/page/agent.vue'),
    },
    {
        path:"/pay",
        name:"pay",
        component:()=>import('@/page/pay.vue'),
    },
    {
        path:"/okPay",
        name:"okPay",
        component:()=>import('@/page/okPay.vue'),
    },
    {
        path:"/goods",
        name:"goods",
        component:()=>import('@/page/goods.vue'),
    },
    {
        path:"/memberRefund",
        name:"memberRefund",
        component:()=>import('@/page/memberRefund.vue'),
    },
    {
        path:"/agentPanel",
        name:"agentPanel",
        component:()=>import('@/page/agentPanel.vue'),
    },
    {
        path:"/undo",
        name:"undo",
        component:()=>import('@/page/undo.vue'),
    },
    {
        path:"/undoOk",
        name:"undoOk",
        component:()=>import('@/page/undoOk.vue'),
    },
    {
        path:"/leader",
        name:"leader",
        component:()=>import('@/page/leader.vue'),
    },
    {
        path:"/cashierFundsStatistics",
        name:"cashierFundsStatistics",
        component:()=>import('@/page/cashierFundsStatistics.vue'),
    },
    
]
const router = createRouter({
    history: createWebHashHistory(),
    routes
});
export default router;



